import angular from 'angular';

ProducerDeclarationsController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window'
];

function ProducerDeclarationsController (ApplicationService, $scope, $location, $window) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.declarations = formData.declarations;
    $scope.previousStep = previousStep;
    $scope.submitForm = submitForm;
  }

  function previousStep () {
    $location.path('/application/commission-assignment');
  }

  // recursively clear out explanations if "no" was selected

  function cleanDeclarations (questionsAndResponses) {
    Object.keys(questionsAndResponses).forEach(function (key) {
      var question = questionsAndResponses[key];
      if (!question.response) {
        question.explanation = '';
      }
      if (question.subQuestions) {
        cleanDeclarations(question.subQuestions);
      }
    });
  }

  function submitForm (form) {
    if (form.$valid) {
      var declarations = angular.copy($scope.declarations);
      cleanDeclarations(declarations.questionsAndResponses);

      var data = {
        declarations: declarations
      };
      ApplicationService.setData(data);
      $scope.loading = true;
      $window.scrollTo(0, 0);
      ApplicationService.submit(false).then(function () {
        $scope.failure = false;
        $scope.loading = false;
        $location.path('/application/review');
      }, function () {
        $scope.failure = true;
        $scope.loading = false;
      });
    }
  }

  init();
}

export default ProducerDeclarationsController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/ProducerDeclarationsController.js
// module id = 23
// module chunks = 0